define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "moment",
  "./taskWizardTemplatePageView",
], function (Marionette, $, Messenger, moment, TaskWizardTemplatePageView) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "taskWizardTemplatePage";
      this.isLastPage = true;
    },
    show: function (task) {
      this.task = task;
      this.view = new TaskWizardTemplatePageView.templatePageView({ model: this.task });
      this.view.on("change:template", this._onChangeTemplate, this);
      this.showRegion(this.view);
    },
    commitData: function () {
      this.view.clearErrors();
      this.task.set({
        description: this.view.getTaskDescription(),
        name: this.view.getTaskName(),
        template: this.view.isTemplate(),
        templateDescription: this.view.getTemplateDescription(),
        templateName: this.view.getTemplateName(),
      });
      if (!this.task.get("name")) {
        this.view.nameError($.t("commonMessages.emptyMessage"));
        return false;
      }
      if (!this.task.get("description")) {
        this.view.descriptionError($.t("commonMessages.emptyMessage"));
        return false;
      }
      if (this.task.get("template")) {
        if (!this.task.get("templateName")) {
          this.view.templateNameError($.t("commonMessages.emptyMessage"));
          return false;
        }
        if (!this.task.get("templateDescription")) {
          this.view.templateDescriptionError($.t("commonMessages.emptyMessage"));
          return false;
        }
      }
      return true;
    },
    _onChangeTemplate: function () {
      const template = this.view.isTemplate();
      if (template) {
        this.view.enableTemplateFields();
      } else {
        this.view.disableTemplateFields();
      }
    },
  });
});
